export var TimeoutModalTypes;
(function (TimeoutModalTypes) {
    TimeoutModalTypes["WARNING"] = "WARNING";
    TimeoutModalTypes["SESSION"] = "SESSION";
})(TimeoutModalTypes || (TimeoutModalTypes = {}));
